import { Fragment } from 'react'
import infoSys from 'assets/img/train/summer-institute.png'
import oceanside from 'assets/img/common/oceanside-community-foundation.png'

export const banner = {
  bannerTitle: 'AI will change',
  rotatingWords: [
    'Healthcare',
    'Finance',
    'Policymaking',
    'Conservation',
    'Defense',
    'Education',
    'Aerospace',
    'Entertainment',
  ],
  bannerSubTitle: 'Prepare your students to be responsible ai leaders',
  secondSubTitle: [
    'Artificial Intelligence Professional Development for High School Educators',
    'Virtual',
    <Fragment>
      <span className="font-seg-ui-reg">Summer 2026 dates announced soon!</span>
    </Fragment>,
  ],
  thirdSubTitle: (
    <Fragment>
      <span className="fs-26"><span className='font-seg-ui-bold'>FREE</span> - sponsored by </span>{' '}
      <img
        className="ml-20 bg-white p-10"
        style={{ maxWidth: 150 }}
        src={infoSys}
        alt="Info System"
      />
      {/* {' '}&amp;{' '}
      <img
        style={{ maxWidth: 80 }}
        src={oceanside}
        alt="Oceanside Community Foundation"
      /> */}
    </Fragment>
  ),
  buttons: [
    // {
    //   isExternal: true,
    //   title: 'Create Account',
    //   link: 'https://pathfinders.onwingspan.com/web/en/login',
    // },
    {
      isExternal: true,
      title: '2026 Interest form',
      link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
    },
  ],
  // afterButtonText: (
  //   <Fragment>
  //     *To register: create an account on the Pathfinders site. Next, click on
  //     the ‘register’ button & enroll in the course.
  //   </Fragment>
  // ),
}
